// Logger léger : silencieux en production, verbeux en développement.
const isDev = process.env.NODE_ENV !== "production";

export function logWarn(...args) {
  if (isDev) console.warn(...args);
}
